export type Subdomain = 'main' | 'stats' | 'live' | 'admin' | 'localhost'

export function getSubdomain(): Subdomain {
  const hostname = window.location.hostname
  
  // Local development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // Check for subdomain simulation via query param
    const params = new URLSearchParams(window.location.search)
    const simulated = params.get('subdomain') as Subdomain | null
    if (simulated && ['main', 'stats', 'live', 'admin'].includes(simulated)) {
      return simulated
    }
    return 'localhost'
  }
  
  // Handle *.pages.dev URLs (Cloudflare Pages preview deployments)
  // e.g., abc123.n0n3-site.pages.dev or n0n3-site.pages.dev
  if (hostname.endsWith('.pages.dev')) {
    const params = new URLSearchParams(window.location.search)
    const simulated = params.get('subdomain') as Subdomain | null
    if (simulated && ['main', 'stats', 'live', 'admin'].includes(simulated)) {
      return simulated
    }
    return 'main'
  }
  
  // Production - extract subdomain from *.n0n3.com
  const parts = hostname.split('.')
  
  // Handle n0n3.com (no subdomain) -> main
  if (parts.length === 2 && hostname === 'n0n3.com') {
    return 'main'
  }
  
  // Handle stats.n0n3.com, live.n0n3.com, admin.n0n3.com, etc.
  if (parts.length >= 3) {
    const subdomain = parts[0].toLowerCase()
    
    switch (subdomain) {
      case 'stats':
        return 'stats'
      case 'live':
        return 'live'
      case 'admin':
        return 'admin'
      case 'www':
        return 'main'
      default:
        return 'main'
    }
  }
  
  return 'main'
}

export function getApiUrl(): string {
  const hostname = window.location.hostname
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return '/api' // Proxied by Vite
  }
  
  // For pages.dev preview deployments, use the workers.dev URL
  if (hostname.endsWith('.pages.dev')) {
    return 'https://n0n3-api.hello-2c6.workers.dev'
  }
  
  // Use custom domain for proper cookie sharing across *.n0n3.com
  return 'https://api.n0n3.com'
}
